import React from 'react';
import SidebarNav from './SidebarNav';
import BottomNav from './BottomNav';
import SiteFooter from './SiteFooter';
import StatusBar from './StatusBar';
import PWAInstallPrompt from './PWAInstallPrompt';

interface AppLayoutProps {
  children: React.ReactNode;
}

export default function AppLayout({ children }: AppLayoutProps) {
  return (
    <div className="flex min-h-screen w-full" style={{ background: 'var(--background)' }} suppressHydrationWarning>
      <SidebarNav />
      <div className="flex-1 min-w-0 flex flex-col">
        <main className="flex-1 pb-28 lg:pb-0">
          {children}
        </main>
        <SiteFooter />
      </div>
      <BottomNav />
      <StatusBar />
      <PWAInstallPrompt />
    </div>
  );
}